// @ts-nocheck
import type * as Types from '../../../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentUserTicketOrderFragment = { __typename?: 'CurrentUserTicketOrder', id: string, created: number, amount: number, ticketCount: number, paymentMethodType: Types.CurrentUserPaymentMethodType, workspaceWebId: string };

export type CurrentUserTicketFragment = { __typename?: 'CurrentUserTicket', id: string, status: Types.TicketStatus, attendeeFirstName?: string | null, attendeeLastName?: string | null, ticketTypeName: string };

export type CurrentUserTicketsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserTicketsQuery = { __typename?: 'Query', currentUserTickets: Array<{ __typename?: 'CurrentUserTicketOrder', id: string, created: number, amount: number, ticketCount: number, paymentMethodType: Types.CurrentUserPaymentMethodType, workspaceWebId: string, page: { __typename?: 'Page', id: string, title: string, startsAt?: number | null, endsAt?: number | null, venueName?: string | null, venueAddress?: string | null }, tickets: Array<{ __typename?: 'CurrentUserTicket', id: string, status: Types.TicketStatus, attendeeFirstName?: string | null, attendeeLastName?: string | null, ticketTypeName: string }> }> };

export const CurrentUserTicketOrderFragmentDoc = /*#__PURE__*/ gql`
    fragment CurrentUserTicketOrder on CurrentUserTicketOrder {
  id
  created
  amount
  ticketCount
  paymentMethodType
  workspaceWebId
}
    `;
export const CurrentUserTicketFragmentDoc = /*#__PURE__*/ gql`
    fragment CurrentUserTicket on CurrentUserTicket {
  id
  status
  attendeeFirstName
  attendeeLastName
  ticketTypeName
}
    `;
export const CurrentUserTicketsDocument = /*#__PURE__*/ gql`
    query CurrentUserTickets {
  currentUserTickets {
    ...CurrentUserTicketOrder
    page {
      id
      title
      startsAt
      endsAt
      venueName
      venueAddress
    }
    tickets {
      ...CurrentUserTicket
    }
  }
}
    ${CurrentUserTicketOrderFragmentDoc}
${CurrentUserTicketFragmentDoc}`;

/**
 * __useCurrentUserTicketsQuery__
 *
 * To run a query within a React component, call `useCurrentUserTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserTicketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserTicketsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserTicketsQuery, CurrentUserTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserTicketsQuery, CurrentUserTicketsQueryVariables>(CurrentUserTicketsDocument, options);
      }
export function useCurrentUserTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserTicketsQuery, CurrentUserTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserTicketsQuery, CurrentUserTicketsQueryVariables>(CurrentUserTicketsDocument, options);
        }
export function useCurrentUserTicketsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserTicketsQuery, CurrentUserTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserTicketsQuery, CurrentUserTicketsQueryVariables>(CurrentUserTicketsDocument, options);
        }
export type CurrentUserTicketsQueryHookResult = ReturnType<typeof useCurrentUserTicketsQuery>;
export type CurrentUserTicketsLazyQueryHookResult = ReturnType<typeof useCurrentUserTicketsLazyQuery>;
export type CurrentUserTicketsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserTicketsSuspenseQuery>;
export function refetchCurrentUserTicketsQuery(variables?: CurrentUserTicketsQueryVariables) {
      return { query: CurrentUserTicketsDocument, variables: variables }
    }